import { redirectToLogin } from "./annoucement-sheet";
import { api, getLanguageCode, getLanguageCodeForbackend } from "./api";
import authHeader from "./auth-header";
export type DropdownDataWithLanguage = {
    id: number;
    name_en: string;
    name_tc: string;
    name_sc: string;
  };
  type ManualResponse = {
    ManualList: TData;
  };
  export type PaginationData = {
    category: string | number | undefined,
    year:string,
    sort:string,
    page?:number,
    limit?:number;
}
  export type TData = {
    data: DepartmentInfo[];
    total: number;
  };
  export type DepartmentInfo = {
    id?: number;
    name: string;
  };

export const manualApi = api.injectEndpoints({
  endpoints: (build) => ({
    getManuals: build.query<ManualResponse, PaginationData>({
      query: ({category,year,sort,page,limit}) => ({
        url: `${getLanguageCodeForbackend()}getmanuals?category=${category}&year=${year}&sort=${sort}&page=${page}&limit=${limit}`,
        headers: authHeader(),
      }),
      keepUnusedDataFor:0,
      transformErrorResponse: (err) => {
        if (err?.status === 401) {
          redirectToLogin();
        }
      },
    }),
  }),
});

export const {
    useGetManualsQuery
} = manualApi;

export const {
  endpoints: {
    getManuals
  },
} = manualApi;
